import * as React from "react";

import { cn } from "@utils/ui";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, style, ...props }, ref) => {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-muted-foreground",
        "field-sizing-content shadow-xs flex min-h-16 w-full rounded-md border border-border bg-transparent px-3 py-2 text-base outline-none transition-all",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "disabled:cursor-not-allowed disabled:opacity-80 aria-invalid:border-destructive",
        "aria-invalid:ring-destructive/20",
        "dark:bg-input/30 md:text-sm",
        "dark:aria-invalid:ring-destructive/40",
        className
      )}
      ref={ref}
      style={style}
      {...props}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
